<template>
    <v-card class="elevation-1 pa-3">
        <div style="text-align: right">
            <v-btn color="orange" dark @click="onChange" v-if="type=='matrix'">
                Tạo đề mới
            </v-btn>
            <v-btn class="yoprimary" dark @click="onCreate" v-if="type=='matrix'">
                <div v-if="exam == null || exam.exam_id == null || exam.exam_id == undefined || exam.exam_id ==''">Lưu đề</div>
                <div v-else>Đã lưu</div>
            </v-btn>
            <!--v-btn color="orange" dark @click="onChange" v-else>
                <v-icon dark left>refresh</v-icon>
                {{$t('lang.common.change')}}
            </v-btn-->
        </div>
        <v-card-text style="text-align: center">
            <h3 v-if="type=='matrix'">
                <v-text-field
                        label="Tên đề"
                        v-validate="'required'"
                        maxlength="250"
                        data-vv-as="Tên đề"
                        v-model="examination.exam_name"
                        name="exam_name"
                        key="exam_name"
                        :error-messages="errors.first('exam_name')"
                />
            </h3>
            <h3 v-else>{{examination.exam_name}}</h3>
            <div :id="id" class="exam_content">
            </div>
        </v-card-text>
        <v-card-actions v-if="(examId != null || exam !=null) && type=='select' || type =='matrix'">
            <v-spacer></v-spacer>
            <v-btn color="black" dark @click="onDelete" v-if="type=='matrix'">
                Xóa đề
            </v-btn>
            <v-btn @click="viewAnswerDetail">
                {{ $t('lang.exercise.viewAnswer') }}
            </v-btn>
            <v-btn color="black" dark @click="onSave">
                Chọn đề này
            </v-btn>
            <v-btn @click="cancel">
                Quay lại
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import {message} from "../../services";
    import axios from "axios";

    export default {
        name: "yolearn-question",
        components: {},

        props: {
            id: {
                type: String,
                default: () => {
                    return 'select';
                }
            },

            type: {
                type: String,
                default: () => {
                    return "";
                }
            },

            classId: {
                type: String | Number,
                default: () => {
                    return null;
                }
            },
            examId: {
                type: String | Number,
                default: () => {
                    return null;
                }
            },
            exam: {
                type: Object,
                default: () => {
                    return null;
                }
            },
        },
        data() {
            return {
                uploadAnswer: null,
                examination: {},
                viewAnswer: false,
                question: [],
            };
        },

        watch: {
            examId: function (data) {
                console.log("--- examid ---");
                console.log(data);
                this.viewAnswer = false;
                this.previewExam();
            },
            type: function (data) {
                console.log("type:"+data);
                this.previewExam();
            },
            exam: function(data){
                this.viewAnswer = false;
                this.previewExam();
            }
        },

        created() {
            if (this.examId != null || this.exam != null) {
                this.previewExam();
            }
        },

        computed: {},

        methods: {
            addMathDocument: function (divId, content) {
                /*
                                let div = document.createElement("div");
                                div.setAttribute("id", divId);
                                let main = document.getElementById(parentId);
                                main.appendChild(div);
                */

                typeset(() => {
                    let math = document.getElementById(divId);
                    math.innerHTML = content;
                    return math;
                });

            },

            renderExam: function () {
                let main = document.getElementById(this.id);
                main.innerHTML = "";
                for (let i = 0; i < this.question.length; i++) {
                    let question = document.createElement("div");
                    question.setAttribute("id", this.id + "_question_" + this.question[i].question_id);
                    question.setAttribute("class", "question");
                    main.appendChild(question);
                    let questionTitle = document.createElement("div");
                    questionTitle.setAttribute("class", "questionTitle");
                    questionTitle.innerHTML = "Câu " + (i + 1);
                    question.appendChild(questionTitle);
                    let questionContent = document.createElement("div");
                    questionContent.setAttribute("id", this.id + "_question_content_" + this.question[i].question_id);
                    question.appendChild(questionContent);
                    this.addMathDocument(this.id + "_question_content_" + this.question[i].question_id, this.question[i].question)
                    for (let j = 0; j < this.question[i].answer.length; j++) {
                        let ans = document.createElement("div");
                        ans.setAttribute("id", this.id + "_answer_" + this.question[i].answer[j].answer_id);
                        if (this.type == 'select' || this.type == "review" || this.type=="matrix") {
                            if (this.question[i].answer[j].answer_id == this.question[i].answer_correct) {
                                ans.setAttribute("class", "right_answer answer");
                            } else {
                                ans.setAttribute("class", "answer");
                            }
                        } else {
                            ans.setAttribute("class", "answer");
                        }
                        question.appendChild(ans);
                        let char = '<label class="bullet">A. </label>';
                        switch (j) {
                            case 0:
                                char = '<label class="bullet">A. </label>';
                                break;
                            case 1:
                                char = '<label class="bullet">B. </label> ';
                                break;
                            case 2:
                                char = '<label class="bullet">C. </label> ';
                                break;
                            case 3:
                                char = '<label class="bullet">D. </label> ';
                                break;

                        }
                        this.addMathDocument(this.id + "_answer_" + this.question[i].answer[j].answer_id, char + this.question[i].answer[j].value)
                    }
                    if (this.viewAnswer) {
                        let ansDetail = document.createElement("div");
                        ansDetail.setAttribute("id", this.id + "_answer_detail_" + this.question[i].question_id);
                        ansDetail.setAttribute("class", "answer_detail");
                        question.appendChild(ansDetail);
                        this.addMathDocument(this.id + "_answer_detail_" + this.question[i].question_id, this.question[i].answer_detail);
                    }
                }
            },

            renderDetailAnswer: function () {
                if (!this.viewAnswer) {
                    return;
                }
                for (let i = 0; i < this.question.length; i++) {
                    let question = document.getElementById(this.id + "_question_" + this.question[i].question_id);
                    if (question == null || question == undefined) {
                        continue;
                    }
                    let ansDetail = document.getElementById(this.id + "_answer_detail_" + this.question[i].question_id);
                    if (ansDetail != null && ansDetail != undefined) {
                        continue;
                    } else {
                        let label = document.createElement("div");
                        label.innerHTML = "Hướng dẫn giải";
                        label.setAttribute("class","answer_title");
                        question.appendChild(label);
                        ansDetail = document.createElement("div");
                        ansDetail.setAttribute("id", this.id + "_answer_detail_" + this.question[i].question_id);
                        ansDetail.setAttribute("class", "answer_detail");
                        question.appendChild(ansDetail);
                        this.addMathDocument(this.id + "_answer_detail_" + this.question[i].question_id, this.question[i].answer_detail);
                    }
                }
            },

            previewExam: function () {
                let examId = this.examId;
                let exam = this.exam;
                if (examId == null || examId == undefined || examId == "") {
                    examId = null;
                }
                if (exam == null || exam == undefined || exam == "") {
                    exam = null;
                }
                if(examId == null && exam == null){
                    this.clearContent();
                    return;
                }
                //console.log(this.examId);
                //console.log(this.exam);
                if (this.exam != undefined && this.exam != null) {
                    this.examination = this.exam;
                    this.question = this.exam.exam_detail;
                    this.renderExam();
                } else {
                    let url = null;
                    //console.log(this.type);
                    if (this.type == "exam") {
                        url = process.env.VUE_APP_YO_LEARN_API + "/exams/exam_detail_question?token=yoclass&exam_id=" + this.examId;
                    } else {
                        url = process.env.VUE_APP_YO_LEARN_API + "/exams/exam_detail?token=yoclass&exam_id=" + this.examId;
                    }
                    axios.get(url).then(
                        data => {
                            this.examination = data;
                            this.question = data.exam_detail;
                            this.renderExam();
                        },
                        error => {
                            console.log(error);
                        }
                    )
                }

            },

            onSave() {
                console.log(this.examination);
                console.log("select ");
                if(this.examination.exam_id == null || this.examination.exam_id == ""){
                    message.error("Đề chưa được lưu");
                    return;
                }
                console.log("---yolearn question emit save ---");
                this.$emit("save", this.examination);
            },

            onCreate() {
                this.$emit("create", this.examination);
            },

            cancel: function () {
                this.$emit("cancel");
            },

            onChange: function () {
                this.$emit("change");
            },

            clearContent(){
                let main = document.getElementById(this.id);
                main.innerHTML = "";
            },

            onDelete:function(){
                this.$emit("delete",this.examination);
            },

            viewAnswerDetail: function () {
                this.viewAnswer = true;
                this.renderDetailAnswer();
            }
        }
    };
</script>
<style>
    .exam_content img {
        max-width: 100%;
        height: auto;
    }
</style>

